var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageBorderless(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53824 6.43652C8.92207 5.7926 9.85208 5.78491 10.2472 6.42188L13.9953 12.4746C14.1934 12.7945 14.6609 12.7892 14.8517 12.4648L16.0705 10.3926C16.4533 9.74231 17.3912 9.7344 17.7853 10.3779L22.0812 17.3975C22.4865 18.0603 22.0133 18.9118 21.2365 18.9189L2.78043 19.0801C2.00092 19.0868 1.51351 18.2382 1.91226 17.5684L8.53824 6.43652Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9464 4C19.0508 4.00025 19.9464 4.89558 19.9464 6C19.9464 7.10442 19.0508 7.99975 17.9464 8C16.8419 8 15.9464 7.10457 15.9464 6C15.9464 4.89543 16.8419 4 17.9464 4Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageBorderless);
export default __webpack_public_path__ + "static/media/ImageBorderless.0f522db9f43d02eda66416a7c7fc158e.svg";
export { ForwardRef as ReactComponent };